import React from "react";

const navBtn = (active) => ({
  padding: "10px 14px",
  borderRadius: 12,
  border: active ? "1px solid #111827" : "1px solid #e5e7eb",
  background: active ? "#111827" : "#fff",
  color: active ? "#fff" : "#111827",
  fontWeight: 600,
  cursor: "pointer",
  boxShadow: active ? "0 8px 20px rgba(17,24,39,0.18)" : "none",
});

export default function UdrzbaLayout({ section, setSection, children, onLogout, onBackToModules }) {
  const items = [
    ["dashboard", "Dashboard"],
    ["zakazky", "Zakázky"],
    ["nova", "Nová zakázka"],
    ["kalendar", "Kalendář"],
    ["cenik", "Ceník"],
    ["ucetnictvi", "Účetnictví"],
  ];

  return (
    <div style={{ padding: 20, background: "#f5f7fb", minHeight: "100vh" }}>
      <div
        style={{
          background: "linear-gradient(135deg, #111827 0%, #1f2937 100%)",
          color: "#fff",
          borderRadius: 20,
          padding: 24,
          boxShadow: "0 16px 40px rgba(17,24,39,0.25)",
          marginBottom: 18,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "start", flexWrap: "wrap" }}>
          <div>
            <div style={{ fontSize: 28, fontWeight: 800 }}>Údržba hrobu CK</div>
            <div style={{ marginTop: 8, opacity: 0.9 }}>
              Interní přehled zakázek, ceníku a podkladů pro účetnictví
            </div>
          </div>

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <button
              onClick={onBackToModules}
              style={{
                padding: "10px 14px",
                borderRadius: 12,
                border: "1px solid rgba(255,255,255,0.35)",
                background: "rgba(255,255,255,0.08)",
                color: "#fff",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Zpět na výběr
            </button>

            <button
              onClick={onLogout}
              style={{
                padding: "10px 14px",
                borderRadius: 12,
                border: "1px solid rgba(255,255,255,0.35)",
                background: "#fff",
                color: "#111827",
                fontWeight: 800,
                cursor: "pointer",
              }}
            >
              Odhlásit
            </button>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: 10,
          flexWrap: "wrap",
          marginBottom: 18,
        }}
      >
        {items.map(([key, label]) => (
          <button
            key={key}
            onClick={() => setSection(key)}
            style={navBtn(section === key)}
          >
            {label}
          </button>
        ))}
      </div>

      <div
        style={{
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: 20,
          padding: 18,
          boxShadow: "0 10px 30px rgba(15,23,42,0.06)",
        }}
      >
        {children}
      </div>
    </div>
  );
}
